import { trustItems } from '@/mocks/categories';

export default function TrustBar() {
  return (
    <section className="w-full bg-background-100 border-y border-background-200/70 py-6 md:py-8">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {trustItems.map((item) => (
            <div key={item.label} className="flex items-center gap-2 text-foreground-700">
              <div className="w-5 h-5 flex items-center justify-center text-primary-500">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium whitespace-nowrap">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}